import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Market } from 'data/terra/Market';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { CommonState } from '../reducer';

export const FETCH_MARKETS = 'FETCH_MARKETS';

export interface FetchMarketsAction {
  type: typeof FETCH_MARKETS;
  markets: Market[];
  error?: string;
}

export const fetchMarkets = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  const result = await Terra.market.fetchMarkets();
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_MARKETS,
      markets: result.get()!.data,
    } as FetchMarketsAction);
  } else {
    dispatch({
      type: FETCH_MARKETS,
      markets: [],
      error: result.exception().message,
    } as FetchMarketsAction);
  }

  return result;
};

export const fetchMarketsDelegate: DelegateMapEntry<
  FetchMarketsAction,
  CommonState
> = {
  [FETCH_MARKETS]: (
    state: CommonState,
    action: FetchMarketsAction
  ): CommonState => {
    return {
      ...state,
      markets: action.markets,
      marketError: action.error,
    };
  },
};
